import { c as _c } from "react/compiler-runtime";
import { getOrgPlaybooksOptions } from '@onefootprint/fetch-dashboard';
import { getErrorMessage } from '@onefootprint/request';
import { useQuery } from '@tanstack/react-query';
import usePagination from '@/hooks/use-pagination';
import usePlaybooksQueryParams from './use-playbooks-query-params';
const usePlaybooks = () => {
  const $ = _c(21);
  const queryParams = usePlaybooksQueryParams();
  const {
    requestParams
  } = queryParams;
  let t0;
  if ($[0] !== requestParams.kinds || $[1] !== requestParams.page || $[2] !== requestParams.search || $[3] !== requestParams.status) {
    t0 = getOrgPlaybooksOptions({
      query: {
        kinds: requestParams.kinds,
        page: requestParams.page,
        search: requestParams.search,
        status: requestParams.status
      }
    });
    $[0] = requestParams.kinds;
    $[1] = requestParams.page;
    $[2] = requestParams.search;
    $[3] = requestParams.status;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  let t1;
  if ($[5] !== queryParams.isReady || $[6] !== t0) {
    t1 = {
      ...t0,
      enabled: queryParams.isReady
    };
    $[5] = queryParams.isReady;
    $[6] = t0;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const query = useQuery(t1);
  const {
    data,
    error
  } = query;
  const t2 = data?.meta?.count;
  const t3 = data?.meta?.nextPage;
  let t4;
  if ($[8] !== queryParams) {
    t4 = newPage => queryParams.push({
      page: newPage
    });
    $[8] = queryParams;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== queryParams.values.page || $[11] !== t2 || $[12] !== t3 || $[13] !== t4) {
    t5 = {
      count: t2,
      next: t3,
      onChange: t4,
      page: queryParams.values.page,
      pageSize: 10
    };
    $[10] = queryParams.values.page;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  const pagination = usePagination(t5);
  let t6;
  if ($[15] !== error) {
    t6 = error ? getErrorMessage(error) : undefined;
    $[15] = error;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  const errorMessage = t6;
  let t7;
  if ($[17] !== errorMessage || $[18] !== pagination || $[19] !== query) {
    t7 = {
      ...query,
      errorMessage,
      pagination
    };
    $[17] = errorMessage;
    $[18] = pagination;
    $[19] = query;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
};
export default usePlaybooks;